import { LetterCloseIcon } from "assets";
import { useTranslation } from "i18n";
import { checkIsCD } from "shared-auth";
import { SELF_REP_SL_EMAIL } from "shared/constants";

interface ISelfRepContactBlockProps {
  onOpenContactPerformerPopUp: () => void;
  seekingRepresentation?: boolean;
}

const SelfRepContactBlock = ({
  onOpenContactPerformerPopUp,
  seekingRepresentation,
}: ISelfRepContactBlockProps) => {
  const { t } = useTranslation();
  const isCd = checkIsCD();

  return (
    <>
      <h2 className="text-s font-semibold leading-5">
        {t("performer:profile.representation.selfRepresented")}
      </h2>
      {seekingRepresentation && (
        <p className="text-s">
          {t("performer:profile.representation.seekingRepresentation")}
        </p>
      )}

      {seekingRepresentation || isCd ? (
        <button
          className="flex items-center gap-2 font-medium text-color-brand-one hover:text-color-brand-two dark:text-blue-aquamarine dark:hover:text-white"
          onClick={onOpenContactPerformerPopUp}
        >
          <LetterCloseIcon width={13} className="shrink-0" />

          {t("performer:profile.representation.button.contact")}
        </button>
      ) : (
        <a
          href={`mailto:${SELF_REP_SL_EMAIL}`}
          className="mt-1 flex items-center gap-2 font-medium text-color-brand-one hover:text-color-brand-two dark:text-blue-aquamarine dark:hover:text-white"
        >
          <LetterCloseIcon width={13} className="shrink-0" />
          {SELF_REP_SL_EMAIL}
        </a>
      )}
    </>
  );
};

export default SelfRepContactBlock;
